import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingPageRoutes } from './landing-page.routing';
import { HeaderComponent } from '../header/header.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { LandingPageComponent } from './landing-page.component';
import { UploadTemplatePopupComponent } from '../dashboard/components/upload-template-popup/upload-template-popup.component';
import { NotePopupComponent } from '../dashboard/components/note-popup/note-popup.component';
import { ParcelModule } from 'single-spa-angular/parcel';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AssetImageUrlPipe } from 'src/app/core/pipes/assetImageUrl.pipe';
import { DragDropDirective } from 'src/app/core/pipes/drag-drop.pipe';
import { ShortenPipe } from 'src/app/core/pipes/shorten.pipe';
import { TooltipDirective } from 'src/app/shared/directives/tooltip/tooltip.directive';
import { ThreeDotsLoadingComponent } from 'src/app/shared/components/three-dots-loading/three-dots-loading.component';
import { ClickOutsideDirective } from 'src/app/core/directives/click-outside.directive';
import { AdminErrorComponent } from '../dashboard/components/admin-error/admin-error.component';
@NgModule({
  imports: [
    ParcelModule,
    LandingPageRoutes,
    CommonModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatIconModule,
    MatSortModule,
    MatProgressBarModule,
  ],
  declarations: [
    TooltipDirective,
    HeaderComponent,
    LandingPageComponent,
    DashboardComponent,
    UploadTemplatePopupComponent,
    AssetImageUrlPipe,
    DragDropDirective,
    ShortenPipe,
    ThreeDotsLoadingComponent,
    ClickOutsideDirective,
    NotePopupComponent,
    AdminErrorComponent
  ],
  exports: [
    TooltipDirective,
    ThreeDotsLoadingComponent,
  ]
})
export class LandingPageModule { }
